import { AUTH_BASE_URL } from "../props";
import { useGet, usePost, useDelete, usePut } from "../common/fetchServices";

const getUserRolesUrl = ({ id }) => `${AUTH_BASE_URL}/users/${id}/roles`;
const getUserRoleUrl = ({ id, role }) =>
  `${AUTH_BASE_URL}/users/${id}/roles/${role}`;
const getUsersOrgRolesUrl = ({ userId, organizationId }) =>
  `${AUTH_BASE_URL}/users/${userId}/organizations/${organizationId}/roles`;

export const useRoles = () => {
  const url = `${AUTH_BASE_URL}/roles`;
  return useGet(["roles", { url }], url);
};

export const useAddUserRoles = () => {
  return usePost(getUserRolesUrl, {
    queriesToInvalidate: [["users", ["id"]]],
  });
};

export const useDeleteUserRole = () => {
  return useDelete(getUserRoleUrl, {
    queriesToInvalidate: [["users", ["id"]]],
  });
};

export const useUpdateUserOrganizationRoles = () => {
  return usePut(getUsersOrgRolesUrl, {
    queriesToInvalidate: [["users", ["id"]]],
  });
};
